import * as domlevel from "./domlevel";

function parseNode(node)
{
  var result;
  switch (node.nodeType)
  {
    case 1: // element
    {
      var nodeName = node.nodeName.toLowerCase();
      if (nodeName == 'div' && node.hasClass("wh-rtd-embeddedobject"))
      {
        result =
            { node:         node
            };
      }
      else
      {
        result =
            { node:         node
            , childNodes:   []
            , attrs:        domlevel.getAllAttributes(node)
            };
      }
    } break;
    case 3: // text
    case 4: // cdata
    {
      result =
          { node:         node
          , hasvalue:     true
          , nodeValue:    node.nodeValue
          };
    } break;
    default: // rest
    {
      result =
          { nodeType:     -1
          , node:         node
          };
    }
  }
  return result;
}

function generateSnapshotRecursive(node, resultlist)
{
  Array.slice(node.childNodes).forEach(function(subnode)
  {
    var parsed = parseNode(subnode);
    resultlist.push(parsed);

    if (parsed.childNodes)
      generateSnapshotRecursive(subnode, parsed.childNodes);
  });
}

function restoreNode(doc, item)
{
  var result = item.node;
  if (item.attrs)
    domlevel.setAttributes(result, item.attrs);
  if (item.childNodes)
    result.empty();
  if (item.hasvalue)
  {
    try
    {
      // IE sometimes transforms text nodes to EmptyTextNodes - can't change nodeValue, can't insert
      result.nodeValue = item.nodeValue;
    }
    catch (e)
    {
      // If that happens, don't care about browser undo anymore
      result = doc.createText(item.nodeValue);
    }
    console.log('new value', result, result.value);
  }

  return result;
}

function restoreSnapshotRecursive(doc, node, resultlist)
{
  var currentnode = null;

  // Convert the nodes, insert them at the beginning of the node childlist
  resultlist.forEach(function(item)
  {
    var subnode = restoreNode(doc, item);

    var nextnode = currentnode ? currentnode.nextSibling : node.firstChild;
    if (subnode != nextnode)
      node.insertBefore(subnode, nextnode);
    currentnode = subnode;

    if (item.childNodes)
      restoreSnapshotRecursive(doc, subnode, item.childNodes);
  });

  // Remove remaining nodes after the inserted nodes
  while (true)
  {
    var nextnode = currentnode ? currentnode.nextSibling : node.firstChild;
    if (!nextnode)
      break;
    node.removeChild(nextnode);
  }
}

/** Takes a snapshot of the current contents of rootnode
    @param rootnode Rootnode to take the snapshot of
    @param range Range to save (selection range)
    @return Snapshot record
*/
function  generateSnapshot (rootnode, range)
{
  var snapshot =
      { rootnode: rootnode
      , nodes:    []
      , range:    range.clone()
      };

  generateSnapshotRecursive(rootnode, snapshot.nodes);

  return snapshot;
}

/** Restores a snapshot taken earlier
    @param rootnode Rootnode to restore the snapshot to
    @param range Range to save (selection range)
    @return Snapshot record
*/
function restoreSnapshot(rootnode, snapshot)
{
  restoreSnapshotRecursive(rootnode.ownerDocument, rootnode, snapshot.nodes);

  var range = snapshot.range.clone();
  if (range.start.element == snapshot.rootnode)
    range.start.element = rootnode;
  if (range.end.element == snapshot.rootnode)
    range.end.element = rootnode;

  return range;
}

module.exports = { generateSnapshot: generateSnapshot
                 , restoreSnapshot: restoreSnapshot
                 };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/components/richeditor/internal/snapshots.es